import { FC } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Row, Typography } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { MiddleDot, SmallTag } from '@/shared';

import { useSearchCompanySyncProgress } from '../../searchCompanySyncProgressState';

const Header: FC = (): JSX.Element => {
    const { token } = useAntDesignTheme();
    const { progress } = useSearchCompanySyncProgress();

    return (
        <Row style={{ padding: '1.5rem', borderBottom: `1px solid ${token.colorBorder}` }} align='middle'>
            <Typography.Title level={4} style={{ marginBottom: 0 }}>
                Search
            </Typography.Title>
            {progress ? (
                <SmallTag
                    message={
                        <span
                            aria-live='polite'
                            role='status'
                            style={{ alignItems: 'center', color: token.colorTextTertiary, display: 'inline-flex' }}
                        >
                            <LoadingOutlined spin style={{ marginRight: '0.375rem' }} />
                            Sync {progress.companyCount.toLocaleString()}{' '}
                            {progress.companyCount === 1 ? 'Company' : 'Companies'}
                            <MiddleDot horizontalMargin='0.375rem' />
                            {progress.completedCompanyCount.toLocaleString()} of{' '}
                            {progress.companyCount.toLocaleString()} Complete ({progress.percentage.toLocaleString()}%)
                        </span>
                    }
                    styles={{ marginLeft: '0.75rem', whiteSpace: 'nowrap' }}
                />
            ) : null}
        </Row>
    );
};

export default Header;
